import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Wordmark } from "./design";

export default function AdminHeader() {
  const { user, signOutNow } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      style={{
        background: "var(--paper-100)",
        borderBottom: "1px solid rgba(43,26,15,0.10)",
      }}
    >
      <div
        style={{
          maxWidth: 1080,
          margin: "0 auto",
          padding: "18px 22px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        <Link
          to="/admin"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            textDecoration: "none",
          }}
          aria-label="Vitanara Admin"
        >
          <Wordmark />
          <AdminBadge />
        </Link>
        <nav
          style={{
            display: "none",
            alignItems: "center",
            gap: 18,
          }}
          data-mq-md
        >
          <AdminNavLink to="/admin" end>Erzähler</AdminNavLink>
          <AdminNavLink to="/admin/codes">Codes</AdminNavLink>
          <AdminNavLink to="/admin/admins">Admins</AdminNavLink>
        </nav>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          {user && (
            <span
              className="t-caps"
              style={{
                color: "var(--ink-faint)",
                display: "none",
              }}
              data-mq-sm
            >
              {user.email}
            </span>
          )}
          <button
            onClick={async () => {
              await signOutNow();
              navigate("/admin/login");
            }}
            style={{
              background: "transparent",
              border: "none",
              padding: 0,
              cursor: "pointer",
              fontFamily: "var(--f-ui)",
              fontSize: 14,
              color: "var(--ink-soft)",
              textDecoration: "underline",
              textUnderlineOffset: 4,
              textDecorationColor: "rgba(43,26,15,0.25)",
            }}
          >
            Abmelden
          </button>
        </div>
      </div>
      <style>{`
        @media (min-width: 640px) {
          [data-mq-sm] { display: inline !important; }
        }
        @media (min-width: 768px) {
          [data-mq-md] { display: inline-flex !important; }
        }
      `}</style>
    </header>
  );
}

function AdminNavLink({
  to,
  end,
  children,
}: {
  to: string;
  end?: boolean;
  children: React.ReactNode;
}) {
  return (
    <NavLink
      to={to}
      end={end}
      style={({ isActive }) => ({
        fontFamily: "var(--f-ui)",
        fontSize: 14,
        textDecoration: "none",
        color: isActive ? "var(--ink)" : "var(--ink-soft)",
        fontWeight: isActive ? 600 : 400,
        borderBottom: isActive
          ? "2px solid var(--oxblood)"
          : "2px solid transparent",
        paddingBottom: 2,
      })}
    >
      {children}
    </NavLink>
  );
}

export function AdminBadge() {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        background: "var(--oxblood)",
        color: "#fff",
        fontFamily: "var(--f-ui)",
        fontSize: 11,
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.18em",
        padding: "3px 9px",
        borderRadius: 999,
        lineHeight: 1.2,
      }}
    >
      Admin
    </span>
  );
}
